import { DialogContent, CircularProgress, LinearProgress } from '@mui/material';

type ProcessingStage = 'validating' | 'executing' | null;

interface ProcessingViewProps {
  processingStage: ProcessingStage;
  progress: { done: number; total: number };
}

const ProcessingView = ({ processingStage, progress }: ProcessingViewProps) => (
  <DialogContent sx={{ py: 6 }}>
    <div className='flex flex-col items-center gap-4 px-4'>
      <CircularProgress size={36} />
      {processingStage === 'validating' ? (
        <>
          <p className='text-gray-700 font-bold text-[15px]'>
            {progress.total > 1
              ? `Validando pedidos... lote ${progress.done}/${progress.total}`
              : 'Validando pedidos...'}
          </p>
          {progress.total > 1 && (
            <div className='w-full'>
              <LinearProgress
                variant='determinate'
                value={(progress.done / progress.total) * 100}
              />
            </div>
          )}
        </>
      ) : (
        <p className='text-gray-700 font-bold text-[15px]'>
          Aplicando cambios de estado...
        </p>
      )}
    </div>
  </DialogContent>
);

export default ProcessingView;
